"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.employeeRoleFragment = exports.employeeFragment = void 0;
exports.employeeFragment = `
    fragment bosEmployee on BosEmployee {
        type
        id
        departmentName
        departmentNumber
        partitionKey
        timestamp
        firstName
        lastName
        phone
        email
        emailVerifiedForSantanderSale
        employeeId
        dealers {
          dealerId
          name
          ownershipTypeDescription
        }
        employeeRoles {
            ...bosEmployeeRole
        }
    }
`;
exports.employeeRoleFragment = `
    fragment bosEmployeeRole on BosEmployeeRole {
        dealerId
        dealerName
        role
        contractType
        modelCode
        brandCode
    }
`;
//# sourceMappingURL=employee.js.map